import React from 'react';
import logo from '../assets/logo.png'
export default function Brand() {
  return (
    <>
      <style>{`
        .brand-section {
          background-color: #8B196A;
          color: white;
          padding: 80px 40px;
          position: relative;
          overflow: hidden;
        }

        .container {
          max-width: 1400px;
          margin: 0 auto;
        }

        .top-section {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 60px;
          gap: 40px;
        }

        .main-heading {
          flex: 1;
          font-size: 3.5rem;
          color: white;
          font-weight: 700;
          line-height: 1.2;
          margin: 0;
        }

        .stats-wrapper {
          display: flex;
          gap: 80px;
          flex: 1;
        }

        .stat-box {
          flex: 1;
        }

        .stat-number {
          font-size: 5rem;
          color: white;
          font-weight: 700;
          line-height: 1;
          margin-bottom: 15px;
        }

        .stat-title {
          font-size: 1.5rem;
          color: white;
          font-weight: 600;
          margin-bottom: 12px;
        }

        .stat-description {
          font-size: 1rem;
          line-height: 1.6;
          color; white;
          opacity: 0.95;
        }

        .cta-buttons {
          display: flex;
          gap: 0;
          max-width: 900px;
          margin: 0 auto 50px;
          box-shadow: 0 10px 40px rgba(0,0,0,0.2);
        }

        .cta-btn {
          flex: 1;
          padding: 30px 40px;
          font-size: 1.8rem;
          font-weight: 600;
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
          color: white;
        }

        .cta-btn-dark {
          background-color: #2d2d2d;
        }

        .cta-btn-dark:hover {
          background-color: #1a1a1a;
          transform: translateY(-3px);
        }

        .cta-btn-purple {
          background-color: white;
          color: black;
        }

        .cta-btn-purple:hover {
          background-color: white;
          transform: translateY(-3px);
        }

        .services-list {
          display: flex;
          justify-content: center;
          gap: 40px;
          margin-bottom: 50px;
          flex-wrap: wrap;
        }

        .service-item {
          font-size: 1.1rem;
          font-weight: 600;
          letter-spacing: 1px;
          text-transform: uppercase;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .service-item::before {
          content: '•';
          font-size: 1.5rem;
        }

        .logo-container {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .logo-box {
          background-color: white;
          padding: 20px 30px;
          border-radius: 12px;
          box-shadow: 0 10px 40px rgba(0,0,0,0.2);
          min-width: 200px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .logo-placeholder {
          width: 120px;
          height: 80px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          font-weight: 700;
          color: white;
        }

        .enquire-badge {
          position: fixed;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          background-color: #1a1a1a;
          color: white;
          writing-mode: vertical-rl;
          text-orientation: mixed;
          padding: 30px 15px;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 2px;
          cursor: pointer;
          z-index: 100;
          transition: all 0.3s ease;
        }

        .enquire-badge:hover {
          padding-right: 20px;
          background-color: #E91E63;
        }

        @media (max-width: 1200px) {
          .top-section {
            flex-direction: column;
          }

          .main-heading {
            font-size: 2.5rem;
          }

          .stat-number {
            font-size: 4rem;
          }

          .stats-wrapper {
            gap: 40px;
          }
        }

        @media (max-width: 968px) {
          .cta-buttons {
            flex-direction: column;
          }

          .main-heading {
            font-size: 2rem;
          }

          .stat-number {
            font-size: 3rem;
          }

          .stat-title {
            font-size: 1.2rem;
          }

          .services-list {
            gap: 20px;
          }

          .service-item {
            font-size: 0.9rem;
          }
        }

        @media (max-width: 768px) {
          .stats-wrapper {
            flex-direction: column;
            gap: 30px;
          }

          .cta-btn {
            font-size: 1.4rem;
            padding: 25px 30px;
          }
        }
      `}</style>

      <section className="brand-section">
        <div className="container">
          {/* Top Section - Heading and Stats */}
          <div className="top-section">
            <h1 className="main-heading">
Elevate Your Business with
<br />
             Intelligence, Innovation, <br />
           Precision, and Impact.

            </h1>





            <div className="stats-wrapper">
              <div className="stat-box">
                <div className="stat-number">90%</div>
                <h3 className="stat-title">In-House Expertise</h3>
                <p className="stat-description text-light">
                 Complete AI Strategy, Model Development, Data Analytics, Automation, and Application Deployment.
                </p>
              </div>

              <div className="stat-box">
                <div className="stat-number">10%</div>
                <h3 className="stat-title">Collaborative Expertise</h3>
                <p className="stat-description text-light">
Cloud Integration, Hardware Deployment, Specialized Data Acquisition, and External Partnerships for seamless AI solutions.

                </p>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="cta-buttons">
            <button className="cta-btn cta-btn-dark">
              It's Right Time
            </button>
            <button className="cta-btn cta-btn-purple">
              Connect With Us
            </button>
          </div>

          {/* Services List */}
          <div className="services-list">
            <div className="service-item">AI Strategy</div>
            <div className="service-item">AI Development</div>
            <div className="service-item">Intelligent Automation</div>
          </div>

          {/* Logo Container */}
          <div className="logo-container">
            <div className="logo-box">
              <div className="logo-placeholder"><img src={logo} alt="" width="180px" height="27px" /></div>
            </div>
          </div>
        </div>

        {/* Enquire Now Badge */}
        {/* <div className="enquire-badge">
          Enquire Now ↑
        </div> */}
      </section>
    </>
  );
}